export { default as VirtualServiceAgentHeaderDumb } from './virtual-service-agent-header-dumb';
